





















































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Building } from '@/models'
import { Utils } from '@/utils'
import UpsertBuildingModal from '@/components/modals/UpsertBuildingModal.vue'

@Component({
  components: { UpsertBuildingModal }
})
export default class Buildings extends Vue {
  private buildings: Building[] = []
  private loading = false
  private searchFilter = ''
  private selectedBuilding: Building = { id: 0, name: '' }

  private fields = [
    { key: 'id', label: 'ID', sortable: true },
    { key: 'name', label: this.$t('buildings_view.columns.name'), sortable: true },
    { key: 'createdOn', label: this.$t('buildings_view.columns.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredBuildings(): Building[] {
    if (!this.searchFilter.trim()) return this.buildings
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.buildings.filter(building => {
      const name = Utils.normalizeText(building.name)
      return name.includes(filterNormalized)
    })
  }

  async created() {
    await this.loadBuildings()
  }

  async loadBuildings() {
    try {
      this.loading = true
      this.buildings = await ApiClient.getBuildings()
    } catch (error) {
      console.error('Error loading buildings:', error)
      this.$bvToast.toast(this.$t('buildings_view.error_loading').toString(), {
        title: this.$t('buildings_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.selectedBuilding = { id: 0, name: '' }
    this.$nextTick(() => this.$bvModal.show('UpsertBuildingModal'))
  }

  openEditModal(building: Building) {
    this.selectedBuilding = { ...building }
    this.$nextTick(() => this.$bvModal.show('UpsertBuildingModal'))
  }

  async onBuildingSaved() {
    await this.loadBuildings()
    this.$bvToast.toast(this.$t('buildings_view.saved_success').toString(), {
      title: this.$t('feedback.feedback_message_success_title').toString(),
      variant: 'success',
      solid: true,
      autoHideDelay: 2000
    })
  }

  async confirmDelete(building: Building) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      this.$t('buildings_view.confirm_delete', { name: building.name }).toString(),
      {
        title: this.$t('buildings_view.confirm_delete_title').toString(),
        okVariant: 'danger',
        okTitle: this.$t('button_actions.remove').toString(),
        cancelTitle: this.$t('button_actions.cancel').toString(),
        centered: true
      }
    )

    if (!confirmed) return

    try {
      await ApiClient.deleteBuilding(building.id)
      this.$bvToast.toast(this.$t('buildings_view.deleted_success').toString(), {
        title: this.$t('feedback.feedback_message_success_title').toString(),
        variant: 'success',
        solid: true
      })
      await this.loadBuildings()
    } catch (error: any) {
      console.error('Error deleting building:', error)
      this.$bvToast.toast(error.message || this.$t('buildings_view.error_deleting').toString(), {
        title: this.$t('buildings_view.error_title').toString(),
        variant: 'danger',
        solid: true
      })
    }
  }
}
